// extracted by mini-css-extract-plugin
export default {"box":"DHkKGTn0N4suGM14uvBU","currentPrice":"FDrtcOGQ6utZciFBLV70"};